"use strict";

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Credit to the Reactstrap project for this gem, https://github.com/reactstrap/reactstrap/blob/master/src/utils.js
// Maps class names to a CSS module.
var mapToCssModules = function mapToCssModules(className, cssModule) {
  if (!cssModule) {
    return className;
  }

  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
};

var _default = mapToCssModules;
exports.default = _default;
//# sourceMappingURL=mapToCssModules.js.map